import {PayloadAction} from "@reduxjs/toolkit";
import {Dispatch} from "react";
import {Option} from "../shared/utilities/OptionT";
import {OrderService} from "../service/Order/OrderService";
import {CheckoutRequest, CheckoutRequestNewUser} from "../shared/entities/Client/CheckoutRequest";

export class OrderController {
    private dispatch: Dispatch<PayloadAction<any>>
    private service: OrderService

    constructor(dispatch: Dispatch<PayloadAction<any>>) {
        this.dispatch = dispatch
        this.service = new OrderService(this.dispatch)
    }

    public async getOrder(id: number, unregistered: boolean, email?: string) {
        return this.service.getOrder(id, unregistered, email).then(res => {
            return res
        })
    }

    public async getPaperOrder(id: any) {
        return this.service.getPaperOrder(id).then(res => {
            return res
        })
    }

    public async invoicePdf(data: any) {
        return this.service.invoicePdf(data).then(res => res)
    }

    public async packingSleep(data: any) {
        return this.service.packingSleep(data).then(res => res)
    }

    public async sendInvoice(data: any) {
        return this.service.sendInvoice(data).then(res => res)
    }

    public async getInvoiceInfo(data: any) {
        return this.service.getInvoiceInfo(data).then(res => res)
    }

    public async printPressed(data: any) {
        return this.service.printPressed(data).then(res => res)
    }

    public async removeOrder(id: number) {
        return this.service.removeOrder(id).then(res => res)
    }

    public async chancelOrderPaper(id: number) {
        return this.service.chancelOrderPaper(id).then(res => res)
    }

    public async orderConfirmState(data: any) {
        return this.service.orderConfirmState(data).then(res => res)
    }

    public async cardPaymentDetailsPrintPressed(data: any) {
        return this.service.cardPaymentDetailsPrintPressed(data).then(res => res)
    }

    public async orderUpdate(data: any) {
        console.log(data)
        return this.service.orderUpdate(data).then(res => res)
    }

    public async orderCheckout(data: CheckoutRequest, noRemoveCart?: boolean) {
        return this.service.orderCheckout(data, noRemoveCart).then(res => res)
    }

    public async checkNamePoVins(dealershipId: number, namePo: string) {
        return this.service.checkNamePoVins(dealershipId, namePo).then(res => res)
    }

    public async reorder(data: any) {
        return this.service.reorder(data).then(res => res)
    }

    public async createOrderNewUser(data: CheckoutRequestNewUser) {
        return this.service.createOrderNewUser(data).then(res => res)
    }

    public async getOrderList(data?: any) {
        return this.service.getOrderList(data).then(res => {
            return res
        })
    }

    private static handleResult<T>(res: Option<T>): Option<boolean> {
        if (res?.None) {
            return {
                Some: false,
                None: res.None
            }
        }
        return {Some: true}
    }
}
